import '../../../../src/components/pages/online-booking/neb-page-booking-providers';
import '../../../neb-lit-components/src/components/login/neb-forgot-password';
import '../../../neb-lit-components/src/components/neb-progress-tracker';
import '../../../neb-lit-components/src/components/online-booking/neb-booking-login-controller';
import './date-time/neb-booking-date-page';
import './review-confirm/neb-page-create-account';
import './review-confirm/neb-review-confirm-page';

import { openPopup } from '@neb/popup';
import { matchRouteSwitch } from '@neb/router';
import { css, html, LitElement } from 'lit';

import { createWalkInAppointment } from '../../../../src/api-clients/appointments';
import { fetchQuestionnaireByProviderAndApptTypeBooking } from '../../../../src/api-clients/questionnaires';
import { navigate } from '../../../../src/store';
import { getWalkInPublic } from '../../../neb-api-client/src/availability-api-client';
import { resendPatientUserInvitationByEmail } from '../../../neb-api-client/src/permissions-api-client';
import { createAppointment } from '../../../neb-calendar/neb-appointments-state-public';
import { openError, openSuccess } from '../../../neb-dialog/neb-banner-state';
import { computeTime } from '../../../neb-input/nebFormatUtils';
import { POPUP_RENDER_KEYS } from '../../../neb-popup/src/renderer-keys';
import { connect, store } from '../../../neb-redux/neb-redux-store';
import {
  CSS_COLOR_BLACK,
  CSS_COLOR_WHITE,
  CSS_SPACING,
} from '../../../neb-styles/neb-variables';
import {
  newAppointment,
  updateBookingPage,
} from '../store/booking/bookingAction';

import { EMPTY_LOCATION } from './neb-booking-services';

export const ELEMENTS = {
  createAccountPage: { id: 'create-account-page' },
  datePage: { id: 'page-date' },
  forgotPasswordPage: { id: 'forgot-password-page' },
  progressTracker: { id: 'progress-tracker' },
  providersPage: { id: 'page-provider' },
  reviewConfirmPage: { id: 'page-review-confirm' },
  reviewLogin: { id: 'review-login' },
  servicePage: { id: 'page-service' },
};

export const TEXT_APPOINTMENT_SCHEDULED = 'Appointment Scheduled';
export const TEXT_WALK_IN_APPOINTMENT_SCHEDULED =
  'Appointment scheduled and checked in successfully';
export const TEXT_ERROR_APPOINTMENT_SCHEDULE = 'Unable to create appointment';

const PROGRESS_ITEMS = ['Your Info', 'Confirmation'];
const PROGRESS_ITEMS_WALK_IN = ['Provider', 'Your Info', 'Confirmation'];
const PROGRESS_STEP = {
  '/': 1,
  '/schedule': 2,
  '/schedule/login': 3,
  '/schedule/forgot-password': 3,
  '/schedule/create-account': 3,
  '/schedule/confirm': 4,
};
const PROGRESS_STEP_WALK_IN = {
  '/': 1,
  '/schedule/providers': 2,
  '/schedule/login': 3,
  '/schedule/forgot-password': 3,
  '/schedule/create-account': 3,
  '/schedule/confirm': 4,
};

class NebBookingAppointmentCreator extends connect(store)(LitElement) {
  static get properties() {
    return {
      __locations: Array,
      __appointmentTypeLocation: Array,
      __availableProviders: Array,
      __appointment: Object,
      __availability: Object,
      __page: {
        type: String,
        reflect: true,
      },
      __navItems: Array,
      __providers: Array,
      __selectedProviderId: String,
      __walkInAvailableProviders: Array,
      __processing: Boolean,

      apiPrefix: String,
      isWalkIn: Boolean,
      layout: {
        type: String,
        reflect: true,
      },
      route: String,
      tenantPracticeInfo: Object,
      tenantShortName: String,
      user: Object,
    };
  }

  static get styles() {
    return css`
      :host {
        display: flex;
        flex-direction: column;
      }

      .service-container {
        height: 98%;
        background-color: ${CSS_COLOR_WHITE};
        color: ${CSS_COLOR_BLACK};
      }

      :host([layout='small']) .service-container {
        border-radius: 0;
        height: auto;
        overflow-x: hidden;
      }

      .progress-tracker {
        margin-bottom: 35px;
      }

      .center-text: {
        text-align: center;
      }

      :host([layout='small']) .progress-tracker {
        margin: 0 ${CSS_SPACING} 35px;
        padding-right: 15px;
      }

      :host([layout='small']) .forgot-password {
        margin: 40px ${CSS_SPACING} ${CSS_SPACING};
      }

      :host([layout='small']) .page {
        margin: 0 30px;
      }
    `;
  }

  constructor() {
    super();

    this.__initHandlers();
    this.__initState();
  }

  __initState() {
    this.__locations = [];
    this.__appointment = {};
    this.__appointmentTypeLocation = [];
    this.__walkInAvailableProviders = [];
    this.__availability = {};
    this.__navItems = this.__genNavItems();
    this.__providers = [];
    this.__selectedProviderId = '';
    this.__processing = false;

    this.layout = '';
    this.route = '';
    this.tenantPracticeInfo = {};
    this.tenantShortName = '';
    this.user = {};
    this.isWalkIn = false;
  }

  __initHandlers() {
    this.__handlers = {
      bookAppointment: async () => {
        if (this.__processing) {
          return;
        }

        this.__processing = true;

        try {
          await this.__bookAppointment();
        } catch (e) {
          console.error(e);
          this.__renderErrorBanner();
        } finally {
          this.__processing = false;
        }
      },
      dateFormCompleted: data => {
        this.__appointment = { ...this.__appointment, ...data };
        this.__dispatchNewAppointment();
      },
      selectProvider: providerId => {
        this.__appointment = { ...this.__appointment, providerId };
        this.__dispatchNewAppointment();
      },
      selectService: async (service, locationId) => {
        this.__appointment = {
          ...this.__appointment,
          appointmentTypeId: service.id,
          duration: service.duration,
          durationDisplay: computeTime(service.duration),
          serviceName: service.name,
          locationId,
        };

        store.dispatch(newAppointment(this.__appointment));

        if (this.isWalkIn) {
          this.__walkInAvailableProviders = await getWalkInPublic(
            this.tenantShortName,
            {
              locationId,
              apptTypeId: service.id,
            },
          );

          return navigate('#/walk-in/schedule/providers');
        }

        return navigate('#/book-appointment/schedule');
      },

      login: () => {
        navigate(`#/${this.__getRoutePrefix()}/schedule/confirm`);
      },
      forgotPassword: () => {
        navigate(`#/${this.__getRoutePrefix()}/schedule/forgot-password`);
      },
      cancel: () => {
        navigate(`#/${this.__getRoutePrefix()}/schedule/login`);
      },
      createAccount: () => {
        navigate(`#/${this.__getRoutePrefix()}/schedule/create-account`);
      },
      passwordChanged: () => {
        navigate(`#/${this.__getRoutePrefix()}/schedule/login`);
      },
      setProviderId: id => {
        this.__selectedProviderId = id;
      },
      passwordResent: async email => {
        await resendPatientUserInvitationByEmail(email);

        navigate(`#/${this.__getRoutePrefix()}/schedule/login`);
      },
      save: async questionnaireNarrative => {
        try {
          const appointment = await this.__checkInAppointment(
            questionnaireNarrative,
          );
          return appointment;
        } catch (e) {
          this.__renderErrorBanner();
          return null;
        }
      },
    };
  }

  async __bookAppointment() {
    if (this.isWalkIn) {
      await this.__bookWalkInAppointment();
    } else {
      const appointment = await store.dispatch(
        createAppointment(this.__appointment),
      );

      store.dispatch(updateBookingPage(''));
      store.dispatch(newAppointment({}));
      navigate(`#/appointment/${appointment.id}`);
      store.dispatch(openSuccess(TEXT_APPOINTMENT_SCHEDULED));
    }
  }

  async __bookWalkInAppointment() {
    const { providerId, appointmentTypeId } = this.__appointment;

    const questionnaire = await fetchQuestionnaireByProviderAndApptTypeBooking(
      providerId,
      appointmentTypeId,
    );

    let appointment;

    if (questionnaire) {
      appointment = await openPopup(
        POPUP_RENDER_KEYS.SUBJECTIVE_QUESTIONNAIRE,
        {
          questionnaire,
          onSave: this.__handlers.save,
        },
      );
    } else {
      appointment = await this.__checkInAppointment();
    }

    if (appointment) {
      navigate(`#/walk-in-appointment/${appointment.id}`);
      store.dispatch(openSuccess(TEXT_WALK_IN_APPOINTMENT_SCHEDULED));
    }
  }

  __checkInAppointment(questionnaireNarrative) {
    const { providerId, appointmentTypeId, locationId } = this.__appointment;

    const provider = this.__walkInAvailableProviders.find(
      prov => prov.id === this.__appointment.providerId,
    );

    let nextSlot;

    if (provider && provider.times && provider.times.length) {
      [nextSlot] = provider.times;
    }

    return createWalkInAppointment({
      providerId,
      appointmentTypeId,
      locationId,
      nextSlot,
      selfCheckInQuestionnaireNarrative: questionnaireNarrative,
    });
  }

  __getRoutePrefix() {
    return this.isWalkIn ? 'walk-in' : 'book-appointment';
  }

  __dispatchNewAppointment() {
    store.dispatch(newAppointment(this.__appointment));
    store.dispatch(updateBookingPage('review-confirm'));

    if (this.user && this.user.clientId) {
      navigate(`#/${this.__getRoutePrefix()}/schedule/confirm`);
    } else {
      navigate(`#/${this.__getRoutePrefix()}/schedule/login`);
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this._onBeforeUnloadCallback = this._onBeforeUnload.bind(this);

    window.addEventListener('beforeunload', this._onBeforeUnloadCallback);
  }

  disconnectedCallback() {
    window.removeEventListener('beforeunload', this._onBeforeUnloadCallback);

    super.disconnectedCallback();
  }

  __didBookingChange(state) {
    if (state.booking) {
      if (state.booking.page !== this.__page) {
        this.__page = state.booking.page;
      }

      if (
        state.booking.appointment &&
        state.booking.appointment !== this.__appointment
      ) {
        this.__appointment = state.booking.appointment;
      }
    }
  }

  __didTenantPracticeInfoChange(state) {
    if (
      state.practiceInfo &&
      state.practiceInfo.practiceInfoItems &&
      state.practiceInfo.practiceInfoItems.length > 0 &&
      state.practiceInfo.practiceInfoItems[0] !== this.tenantPracticeInfo
    ) {
      this.tenantPracticeInfo = state.practiceInfo.practiceInfoItems[0];
    }
  }

  _stateChanged(state) {
    this.__didBookingChange(state);

    if (state.availability && state.availability.data) {
      this.__availability = state.availability.data;
    }

    this.__redirectToRootIfNoAppointment();

    if (
      state.providers &&
      state.providers.item &&
      this.__providers !== state.providers.item
    ) {
      this.__providers = state.providers.item;
    }

    this.__didTenantPracticeInfoChange(state);

    this.__didLocationsChange(state);
  }

  __didLocationsChange(state) {
    const practiceInfoItems =
      state.practiceInfo && state.practiceInfo.practiceInfoItems;

    if (practiceInfoItems && practiceInfoItems.length) {
      const locations = practiceInfoItems[0].locations
        .filter(item => item.allowOnlineBooking || item.allowWalkInAppointments)
        .map(item => ({
          ...item,
          label: item.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      this.__locations = [EMPTY_LOCATION, ...locations];
    }
  }

  __genNavItems() {
    return [
      {
        exact: true,
        path: '/',
        resolver: () => html`
          <neb-booking-services
            id="${ELEMENTS.servicePage.id}"
            .layout="${this.layout}"
            .appointment="${this.__appointment}"
            .locations="${this.__locations}"
            .isWalkIn="${this.isWalkIn}"
            .onServiceSelected="${this.__handlers.selectService}"
          ></neb-booking-services>
        `,
      },
      {
        exact: true,
        path: '/schedule',
        resolver: () => html`
          <neb-booking-date-page
            id="${ELEMENTS.datePage.id}"
            .layout="${this.layout}"
            .appointment="${this.__appointment}"
            .onFormCompleted="${this.__handlers.dateFormCompleted}"
          ></neb-booking-date-page>
        `,
      },
      {
        exact: true,
        path: '/schedule/confirm',
        resolver: () => html`
          <neb-review-confirm-page
            id="${ELEMENTS.reviewConfirmPage.id}"
            .tenantShortName="${this.tenantShortName}"
            .appointment="${this.__appointment}"
            .layout="${this.layout}"
            .user="${this.user}"
            .provider="${this.__getProvider()}"
            .locations="${this.tenantPracticeInfo.locations}"
            .onAppointmentBooked="${this.__handlers.bookAppointment}"
          ></neb-review-confirm-page>
        `,
      },
      {
        exact: true,
        path: '/schedule/login',
        resolver: () => html`
          <neb-booking-login-controller
            id="${ELEMENTS.reviewLogin.id}"
            class="page"
            .layout="${this.layout}"
            .onLogin="${this.__handlers.login}"
            .onForgotPassword="${this.__handlers.forgotPassword}"
            .onCreateAccount="${this.__handlers.createAccount}"
          ></neb-booking-login-controller>
        `,
      },
      {
        exact: true,
        path: '/schedule/forgot-password',
        resolver: () => html`
          <neb-forgot-password
            id="${ELEMENTS.forgotPasswordPage.id}"
            class="forgot-password"
            .onCancel="${this.__handlers.cancel}"
            .onPasswordChanged="${this.__handlers.passwordChanged}"
            .onPasswordResent="${this.__handlers.passwordResent}"
          ></neb-forgot-password>
        `,
      },
      {
        exact: true,
        path: '/schedule/create-account',
        resolver: () => html`
          <neb-page-create-account
            id="${ELEMENTS.createAccountPage.id}"
            class="page"
            .layout="${this.layout}"
            .scheduling="${true}"
          ></neb-page-create-account>
        `,
      },
      ...(this.isWalkIn
        ? [
            {
              exact: true,
              path: '/schedule/providers',
              resolver: () => html`
                <neb-page-booking-providers
                  id="${ELEMENTS.providersPage.id}"
                  .layout="${this.layout}"
                  .onSelectProvider="${this.__handlers.selectProvider}"
                  .providers="${this.__walkInAvailableProviders}"
                ></neb-page-booking-providers>
              `,
            },
          ]
        : []),
    ];
  }

  __getProvider() {
    if (!this.__providers) return {};
    return this.__providers.find(p => p.id === this.__appointment.providerId);
  }

  __getProgressItems() {
    let firstItem = 'Service';
    let secondItem = 'Date & Time';

    firstItem = 'Location & Service';

    if (this.layout === 'small') {
      firstItem = html`
        <div style="text-align: center">
          <div>Location</div>
          <div>& Service</div>
        </div>
      `;

      secondItem = html`
        <div style="text-align: center">
          <div>Date</div>
          <div>& Time</div>
        </div>
      `;
    }

    return this.isWalkIn
      ? [firstItem, ...PROGRESS_ITEMS_WALK_IN]
      : [firstItem, secondItem, ...PROGRESS_ITEMS];
  }

  _onBeforeUnload(e) {
    if (
      this.__appointment.appointmentTypeId &&
      this.__page !== 'confirmation'
    ) {
      const message = 'Changes may be lost';
      e.returnValue = message;
      return message;
    }

    return undefined;
  }

  __redirectToRootIfNoAppointment() {
    if (
      !Object.keys(this.__appointment).length &&
      this.route.includes('/schedule') &&
      !this.__isNavigating
    ) {
      this.__isNavigating = true;
      navigate('#/');
    }
  }

  __renderErrorBanner() {
    return store.dispatch(openError(TEXT_ERROR_APPOINTMENT_SCHEDULE));
  }

  update(changedProps) {
    if (changedProps.has('isWalkIn')) {
      this.__navItems = this.__genNavItems();
    }

    super.update(changedProps);
  }

  updated(changedProps) {
    if (changedProps.has('route')) {
      this.__isNavigating = false;

      this.__redirectToRootIfNoAppointment();
    }
  }

  render() {
    return html`
      <div class="service-container">
        <neb-progress-tracker
          id="${ELEMENTS.progressTracker.id}"
          class="progress-tracker"
          .items="${this.__getProgressItems()}"
          .step="${this.isWalkIn
            ? PROGRESS_STEP_WALK_IN[this.route]
            : PROGRESS_STEP[this.route]}"
          .layout="${this.layout}"
        ></neb-progress-tracker>

        ${matchRouteSwitch(this.__navItems, this.route)}
      </div>
    `;
  }
}

customElements.define(
  'neb-booking-appointment-creator',
  NebBookingAppointmentCreator,
);
